<template>
  <div class="my-6 flex items-center">
    <div class="chart-line-marketplace grid h-full grid-cols-2">
      <keep-alive>
        <!-- <v-chart
          autoresize
          :options="chartPie(strategy.portfolio_components)"
        ></v-chart> -->
      </keep-alive>
      <div class="grid grid-cols-2 gap-3 pr-4">
        <div
          content="Risco"
          v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
          :class="
            strategy.strategy_risk == 'BAIXO'
              ? 'bg-ontick-green-900'
              : strategy.strategy_risk == 'MEDIO'
              ? 'bg-ontick-yellow-900'
              : 'bg-ontick-red-900'
          "
          class="self-start rounded-md px-3 py-1 text-center text-xs"
        >
          <span
            :class="
              strategy.strategy_risk == 'BAIXO'
                ? 'text-ontick-green-500'
                : strategy.strategy_risk == 'MEDIO'
                ? 'text-ontick-yellow-500'
                : 'text-ontick-red-500'
            "
          >
            {{ strategy.strategy_risk }}</span
          >
        </div>
        <!-- <div
          content="Modo de operação"
          v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
          :class="colorStatus(strategy.strategy_style)"
          class="
            rounded-md
            px-3
            py-1
            text-xs
            whitespace-nowrap
            self-start
            text-center
          "
        >
          {{
            strategy.strategy_style
              ? strategy.strategy_style.replace("_", " ")
              : "--"
          }}
        </div> -->
        <div v-for="(item, index) in strategy.portfolio_symbols" :key="index">
          <div
            v-show="index < 4"
            class="w-20 self-start rounded-md bg-ontick-teal-600 py-1 text-center text-xs uppercase text-ontick-teal-50"
          >
            {{ item }}
          </div>
          <div
            v-show="index > 4"
            class="w-16 self-start rounded-md bg-ontick-steel-400 px-2 py-0.5 text-center text-sm text-gray-200"
          >
            + {{ index - 4 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ECharts from "@/app/shared/components/chart/echarts";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    // "v-chart": ECharts,
  },

  props: {
    product: { type: Object },
    strategy: { type: Object },
    favorite: { type: Boolean },
    visualization: { type: Boolean },
  },

  computed: {
    ...mapGetters({
      chart_line: "marketplace/chart_line",
    }),
    ...mapState({
      accountTypes: (state) => state.accountTypes,
      color: (state) => state.investment.color,
      config: (state) => state.config,
    }),
  },

  methods: {
    colorStatus(value) {
      let color = "";
      if (value == "DAY_TRADE") {
        color = `bg-ontick-orange-900 text-ontick-orange-500`;
      } else if (value == "SWING_TRADE") {
        color = `bg-ontick-blue-900 text-ontick-blue-500`;
      }
      return color;
    },

    chartPie(value) {
      let dark =
        this.config.ui_theme == "DARK"
          ? this.config.theme_chart.dark
          : this.config.theme_chart.light;

      let color = this.color;
      let option = {
        dataset: {
          dimensions: ["component_volume", "component_name"],
          source: value,
        },

        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },

        grid: {
          top: "5%",
          bottom: "5%",
          left: "0",
          right: "0",
          containLabel: false,
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "100%"],
            selectedMode: "single",
            selectedOffset: 3,
            // clockwise: true,
            itemStyle: {
              borderRadius: 5,
              borderColor: dark.line,
              borderWidth: 2,
              color: function (value) {
                return color[value.dataIndex];
              },
            },

            label: {
              show: false,
              position: "center",
            },

            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "normal",
                textBorderColor: "#fff",
                padding: [3, 8],
                borderRadius: 10,
                formatter: function (value) {
                  return `{a|${value.data.component_name}}\n{hr|}\n {b|${value.data.component_volume}} - {per|${value.percent}%}`;
                },
                backgroundColor: "rgba(23, 30, 39, 0.9)",
                borderColor: "rgba(23, 30, 39, 1)",
                borderWidth: 0,

                color: "#fff",
                rich: {
                  a: {
                    color: "#fff",
                    lineHeight: 28,
                    align: "center",
                  },
                  hr: {
                    borderColor: "#8C8D8E",
                    width: "100%",
                    borderWidth: 0,
                    height: 0,
                  },
                  b: {
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: "bold",
                    lineHeight: 33,
                  },
                  per: {
                    color: "#fff",
                    backgroundColor: "#0694e6",
                    padding: [3, 4],
                    borderRadius: 4,
                  },
                },
              },
            },
            labelLine: {
              show: true,
            },
          },
        ],
      };
      return option;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/app/modules/marketplace/pages/marketplace/marketplace.component.scss";
</style>
